module.exports = __webpack_public_path__ + "static/gallery16-8ebe0c45b0149d82fb815029d271b008.jpg";